import React, { useState } from "react";
import {
  Select,
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { FOLDERS } from "../doseeData/utils/Utils";
import { codeOk, errorMessage } from "../../lib/index";
import { useBannerContext } from "../../context/BannerContext";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FiImage, FiAlignLeft, FiSettings } from "react-icons/fi";

const Add = () => {
  const { createOneBanner } = useBannerContext();
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [type, setType] = useState("home");
  const [bannerStatus, setBannerStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const bannerRoutes = "/banner";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setDescription(null);
  };

  const responses = (isError: any, st: any, msg: any) => {
    setError(isError);
    setStatus(st);
    setErrorMessage(msg);
  };

  const addOneBannerHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, 400, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      status: bannerStatus,
      type: type,
    };

    const response = await createOneBanner(data);
    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={bannerRoutes}
      eyebrow="Marketing • Banners"
      title="Add Banner"
      subtitle="Promote a page with a banner image, target page, and short description."
      icon={<FiImage className="h-5 w-5" />}
      pills={[
        { label: "Page", value: type },
        { label: "Status", value: bannerStatus === 1 ? "Visible" : "Hidden" },
      ]}
      loading={loading}
      submitLabel="Add Banner"
      onSubmit={addOneBannerHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Banner Image"
        hint="1600×600 recommended. JPG or PNG."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.BANNER}
        />
      </AddSection>

      <AddSection
        title="Placement & Status"
        hint="Choose the target page and whether the banner should be visible."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "type",
              title: "Page",
              option: [
                "home",
                "about",
                "tour",
                "market",
                "contact",
                "attraction",
                "best",
                "cities",
                "countries",
                "events",
                "hotels",
                "parties",
                "safaris",
                "timeframe events",
              ],
              onChange: (e: any) => {
                setType(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "banner_status",
              title: "Status",
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setBannerStatus(1);
                else setBannerStatus(0);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="Keep it short — a single sentence works best."
        icon={<FiAlignLeft className="h-4 w-4" />}
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
